<template>
  <div class="project__add">
      <label for="title" >Name</label>
      <div class="_flxrcenter">
        <input name="title" type="text" v-model="title" @keyup.enter="create()" />
        <button title="Create project" class="button" @click="create()">Create</button>
        <button title="Close update" class="button cancel" @click="$emit('close')">
          <i class="material-icons">close</i>
        </button>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'add',
  computed: {
    ...mapGetters(['selectedProject', 'user'])
  },
  data: () => ({
    title: 'My New Project'
  }),
  methods: {
    ...mapActions(['createProject']),
    create: function() {
      const project = { title: this.title };
      this.createProject(project).then(() => {
        this.$emit('close')
      });
    }
  }
}
</script>
